// Chakra imports
import {
  Flex,
  Grid,
  Image,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// assets
import chLogo from "assets/img/logo.png";
import peopleImage from "assets/img/people-image.png";
import logoChakra from "assets/svg/logo-white.svg";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";

import { SearchBar } from "components/Navbars/SearchBar/SearchBar";

// Custom icons
import {
  PersonIcon,
  DocumentIcon,
  GlobeIcon,
  WalletIcon,
} from "components/Icons/Icons.js";
import React from "react";
import { tablesTableData, dashboardTableData, timelineData } from "variables/general";
import ActiveUsers from "./components/ActiveUsers";
import BuiltByDevelopers from "./components/BuiltByDevelopers";
import MiniStatistics from "./components/MiniStatistics";
import OrdersOverview from "./components/OrdersOverview";
import Projects from "./components/Projects";
import SalesOverview from "./components/SalesOverview";
import WorkWithTheRockets from "./components/WorkWithTheRockets";
import Authors from "./components/Authors";


export const lineChartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    theme: "dark",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  xaxis: {
//    type: "datetime",
    categories: [
    ],
    labels: {
          show: false,
      style: {

          show: false,
        colors: "#c8cfca",
        fontSize: "12px",
      },
    },

  },
  yaxis: {
    labels: {
      style: {
        colors: "#c8cfca",
        fontSize: "12px",
      },
    },
  },
  legend: {
    show: false,
  },
  grid: {
    strokeDashArray: 5,
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [],
    },
    // add 10 unique colors:
    colors: ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080' ],
  },
  colors: ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080' ],
};

export default function Dashboard(props) {
  const iconBoxInside = useColorModeValue("white", "white");

// load in data.json from public folder
	const [ filterValue, setFilter ] = React.useState([]);

    // filter data
    const filteredData = props.data.filter((item) => {
        let found = false;
        if (typeof filterValue === "string") {
            // check if filterValue is in item
            if (filterValue.length > 0) {
                found = Object.keys(item).some((key) => {
                    return (item[key] || "").toLowerCase().includes(filterValue.toLowerCase());
                });
            } else {
                found = true;
            }
        } else {
            var filterValueTemp = filterValue.filter((f) => { return typeof f !== "string" });
            // check if filterValue is in item
            if (filterValueTemp.length > 0) {
                found = filterValueTemp.every((filter) => {
                    return item[filter[0]].toLowerCase().includes(filter[1].toLowerCase());
                });
            } else {
                found = true;
            }
        }
        return found;
    });

    // years by country
    const yearsByCountry = filteredData.length > 0 ? filteredData.reduce((acc, item) => {
        if (!acc[item.country]) {
            acc[item.country] = [];
        }
        acc[item.country].push(item.year);
        return acc;
    }, {}) : {};

    const uniqueYears = [...new Set(filteredData.map(item => item.year))].sort();

    // aggregate years by country by country
    Object.keys(yearsByCountry).forEach((key) => {
        if (yearsByCountry[key].length > 0) { yearsByCountry[key] = (yearsByCountry[key]).reduce((acc, item) => {
                if (!acc[item]) {
                    acc[item] = 0;
                }
                acc[item]++;
                return acc;
            }, {});
        }
    });

    // iterate uniqueYears
    Object.keys(yearsByCountry).forEach((key) => {
        uniqueYears.forEach((year) => {
            if (!yearsByCountry[key][year]) {
                yearsByCountry[key][year] = 0;
            }
        });

        yearsByCountry[key] = Object.values(yearsByCountry[key]);
    });

	console.debug(yearsByCountry)
	const chartData = Object.keys(yearsByCountry).map((c) => {
	    return {
	        name: c,
	        data: yearsByCountry[c],
        };
	}) // [yearsByCountry]


const uniqueCountries = [...new Set(filteredData.map(item => item.country))].sort();
//const uniqueYears = [...new Set(filteredData.map(item => item.year))].sort();

  lineChartOptions.xaxis.categories = uniqueYears.map((year) => year.toString());
  return (
    <Flex flexDirection='column' pt={{ base: "0px", md: "0px" }}>
      <SimpleGrid  columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px'>
        <MiniStatistics
          title={"Total Documents"}
          amount={filteredData.length}
          icon={<WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Total Countries"}
          amount={[...new Set(filteredData.map(item => item.country))].length}
          icon={<GlobeIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Total Languages"}
          amount={[...new Set(filteredData.map(item => item.language))].length}
          icon={<DocumentIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Total Authors"}
          amount={[...new Set(filteredData.map(item => item.author))].length}
          icon={<PersonIcon h={"24px"} w={"24px"} color={iconBoxInside} />}
        />
      </SimpleGrid>
      <Grid b='white' style ={{ background: 'white'}}
        templateColumns={{ md: "1fr", lg: "2fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        my='26px'
        b='white'
        gap='24px'>
        <SalesOverview
          title={"Documents by Countries and Years"}
          chartData={filteredData}
          chart={<LineChart chartOptions={ lineChartOptions } chartData={chartData} />}
        />
      </Grid>
      <Grid
        templateColumns={{ sm: "1fr", md: "1fr", lg: "2fr" }}
        templateRows={{ sm: "1fr auto", md: "1fr", lg: "1fr" }}
        gap='24px'>
        <SearchBar filter={filterValue} uniqueYears={uniqueYears} countries={uniqueCountries}

onChangeRest={(e,v) => {
    setFilter([]);
}}
        onChangeCountry={(e,v) => {
        // get value from input
setFilter([...filterValue, ["country",e.target.value]]);
        }}
        onChangeYear={(e,v) => {
        // get value from input
setFilter([...filterValue, ["year",e.target.value]]);
        }}
        onChange={(e,v) => {
        // get value from input
setFilter(e.target.value);
            console.debug(e,e.target.value);
        }} />
        <Authors
                           title={"List of Documents"}
                           captions={["Title", "Year", "Country", "Language"]}
                           filteredData={filteredData}
                         />
      </Grid>
    </Flex>
  );
}
